import React, { useState } from "react";
import { Box, Button, Dialog, TextField } from "@mui/material";
import { DialogContent, Stack, Typography } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import S3FileUpload from "react-s3/lib/ReactS3";
import Config from "../../utils/Config";
import Repo from "../../Repository/Repo";
import { Toast } from "../../components/components/Toast";
import { CashBox } from "../bank/styles";

function AddImage({ onClose, onSuccess, store }) {
  const [loading, setLoading] = useState(false);

  const [image, setImage] = useState("");

  const handleInput = (e) => {
    const files = e.target.files;
    setImage(files[0]);
  };

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  const handleSubmit = async () => {
    try {
      if (!image) {
        Toast("info", "Select Image");
        return;
      }

      setLoading(true);
      let { location } = await S3FileUpload.uploadFile(image, Config());

      let { data } = await Repo.store({
        request: {
          method: "updateStore",
          data: {
            company_code: localStorage.getItem("companyCode"),
            ...store,
            image: location,
          },
        },
      });
      setLoading(false);
      if (data.response.status.statusCode == 200) {
        Toast("success", "Image Uploaded");
        onSuccess({ ...store, image: location });
      } else {
        Toast("error", data.response.status.statusMessage);
        onClose();
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="sm">
      <CashBox sx={{ p: "16px" }}>
        <Typography sx={{ color: "#4eaf51" }}>Add new image</Typography>
        <AddCircleOutlineIcon
          onClick={toggle}
          sx={{ color: "#767676", cursor: "pointer" }}
        />
      </CashBox>
      <DialogContent dividers>
        {store && store.image && (
          <Stack
            alignItems="center"
            width="100%"
            justifyContent="center"
            mt={2.4}
          >
            <Typography sx={{ textAlign: "center" }}>Uploaded Image</Typography>
            <img height="150px" width="150px" src={store.image} alt="" />
          </Stack>
        )}
        <TextField
          size="small"
          fullWidth
          sx={{ my: 2.4 }}
          InputLabelProps={{ shrink: true }}
          type="file"
          onChange={handleInput}
        />

        {loading && (
          <Stack alignItems="center" width="100%" justifyContent="center">
            <ClipLoader size={33} loading={true} color="#4eaf51" />
          </Stack>
        )}
        {!loading && (
          <Button
            fullWidth
            variant="contained"
            sx={{ textTransform: "none" }}
            onClick={handleSubmit}
          >
            <CheckCircleIcon sx={{ mr: "24px", color: "#fff" }} />
            Add New Image
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default AddImage;
